import React from 'react';
import type {
  WidgetPart,
  CTAWidgetPayload,
  ActionEvent,
  WidgetData,
} from '../types';
import CTAWidget from './cta-widget';
import {ListWidget} from './list-widget';
import {TitleWidget} from './title-widget';
import {PromptListWidget} from './prompt-list-widget';


interface WidgetRendererProps {
  part: WidgetPart;
  publishMessageAction?: (action: ActionEvent) => void;
  onResize?: () => void;
}

export function WidgetRenderer({
  part,
  publishMessageAction,
  onResize,
}: WidgetRendererProps) {
  const {data} = part;

  if (data.widget_type === 'list') {
    return (
      <ListWidget
        payload={data.payload}
        publishMessageAction={publishMessageAction}
        onResize={onResize}
      />
    );
  }

  if (data.widget_type === 'cta') {
    return (
      <CTAWidget
        data={data.payload as CTAWidgetPayload}
        publishMessageAction={publishMessageAction}
      />
    );
  }
  if (data.widget_type === 'prompt-list-widget') {
    return (
      <PromptListWidget
        {...data.payload}
        publishMessageAction={publishMessageAction}
      />
    );
  }
  if (data.widget_type === 'title-widget') {
    return <TitleWidget {...data.payload} />;
  }

  return null;
}
